// Utility functions for measuring page performance

/**
 * @internal
 */
export function now(): number {
    return (window.performance && performance.now) ? Math.round(performance.now()) : Date.now();
}

const markNamePrefix = 'EUPL';
function addEUPLPrefix(name: string): string {
    return name.lastIndexOf(`${markNamePrefix}.`) === 0 ? name : `${markNamePrefix}.${name}`;
}

/**
 * @internal
 */
export function mark(name: string): void {
    if (window.performance && performance.mark) {
        performance.mark(addEUPLPrefix(name));
    }
}

/**
 * @internal
 */
export function getMarkTime(name: string): number {
    if (window.performance && performance.mark) {
        let marks: Array<PerformanceEntry> = performance.getEntriesByName(addEUPLPrefix(name));
        return marks && marks.length > 0 ? Math.round(marks[0].startTime) : NaN;
    }
    return NaN;
}

/**
 * @internal
 */
export function measure(name: string, startName: string, endName: string): void {
    if (window.performance && performance.measure) {
        performance.measure(addEUPLPrefix(name), addEUPLPrefix(startName), addEUPLPrefix(endName));
    }
}
